import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = '/api';

function Library() {
  const [sets, setSets] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [importing, setImporting] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [filterLang, setFilterLang] = useState('');
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchSets();
    axios.get(`${API}/categories`).then(res => setCategories(res.data.flat));
  }, []);

  const fetchSets = async (lang = '') => {
    setLoading(true);
    try {
      const url = lang ? `${API}/library?lang=${lang}` : `${API}/library`;
      const res = await axios.get(url);
      setSets(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const handleFilter = (lang) => {
    setFilterLang(lang);
    fetchSets(lang);
  };

const handleImport = async (setId) => {
  setImporting(setId);
  try {
    const res = await axios.post(`${API}/library/${setId}/import`, {
      categoryId: selectedCategory || null
    });
    setMessage({ type: 'success', text: `${res.data.message}` });
    setTimeout(() => setMessage(null), 4000);
  } catch (err) {
    if (err.response?.data?.upgrade) {
      setMessage({
        type: 'error',
        text: 'Bibliothek-Import ist nur für Pro-Benutzer. Upgrade auf Pro!'
      });
    } else {
      setMessage({ type: 'error', text: err.response?.data?.error || 'Import fehlgeschlagen' });
    }
    setTimeout(() => setMessage(null), 5000);
  }
  setImporting(null);
};

  const langLabel = { DE: '🇩🇪', EN: '🇬🇧', FR: '🇫🇷', ES: '🇪🇸', IT: '🇮🇹' };

  const filteredSets = sets.filter(set =>
    search === '' ||
    set.name.toLowerCase().includes(search.toLowerCase()) ||
    (set.description && set.description.toLowerCase().includes(search.toLowerCase())) ||
    (set.topic && set.topic.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div>
      <h1>📚 Bibliothek</h1>
      <p style={{ color: '#718096', marginBottom: '1.5rem' }}>
        Vorgefertigte Kartensets importieren und sofort lernen
      </p>

      <div className="card">
        <input
          type="text"
          placeholder="Bibliothek durchsuchen..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ marginBottom: '1rem' }}
        />
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: '0.85rem', color: '#718096', display: 'block', marginBottom: '0.25rem' }}>
              Nach Sprache filtern
            </label>
            <select value={filterLang} onChange={e => handleFilter(e.target.value)} style={{ margin: 0 }}>
              <option value="">Alle Sprachen</option>
              <option value="EN">🇬🇧 Englisch</option>
              <option value="FR">🇫🇷 Französisch</option>
              <option value="ES">🇪🇸 Spanisch</option>
              <option value="IT">🇮🇹 Italienisch</option>
            </select>
          </div>
          <div style={{ flex: 1 }}>
            <label style={{ fontSize: '0.85rem', color: '#718096', display: 'block', marginBottom: '0.25rem' }}>
              In Kategorie importieren
            </label>
            <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)} style={{ margin: 0 }}>
              <option value="">Keine Kategorie</option>
              {categories.map(cat => (
                <option key={cat.id} value={cat.id}>{cat.name}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {message && (
        <div className={`message message-${message.type}`} style={{ marginBottom: '1rem' }}>
          {message.text}
        </div>
      )}

      {loading && <p>Lade Bibliothek...</p>}

      {!loading && filteredSets.length === 0 && (
        <div className="card" style={{ textAlign: 'center', color: '#718096' }}>
          <p>Keine Sets gefunden.</p>
        </div>
      )}

      {filteredSets.map(set => (
        <div key={set.id} className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: '600', fontSize: '1.1rem', marginBottom: '0.25rem' }}>
                {set.name}
              </div>
              <div style={{ color: '#718096', fontSize: '0.9rem', marginBottom: '0.5rem' }}>
                {set.description}
              </div>
              <div style={{ fontSize: '0.85rem', display: 'flex', gap: '1rem' }}>
                <span>{langLabel[set.source_lang] || set.source_lang} → {langLabel[set.target_lang] || set.target_lang}</span>
                <span style={{ color: '#4c51bf' }}>📖 {set.card_count} Karten</span>
                {set.topic && (
                  <span style={{ background: '#e2e8f0', padding: '0.1rem 0.5rem', borderRadius: '10px' }}>
                    {set.topic}
                  </span>
                )}
              </div>
            </div>
            <button
              className="btn-primary"
              style={{ marginLeft: '1rem', whiteSpace: 'nowrap' }}
              onClick={() => handleImport(set.id)}
              disabled={importing === set.id}
            >
              {importing === set.id ? 'Importiere...' : '⬇ Importieren'}
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Library;